<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择员工"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section>{{scope.row[scope.column.property]}}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  workerList,
} from 'api/system';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'linkman',
      tableSelectTar: 'loginAcct',
      searchBoxDataTmpl: {
        form: [
          { // 员工姓名
            label: '员工姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入员工姓名',
          },
          { // 员工手机
            label: '员工手机',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入员工手机',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'loginAcct',
          label: '登录手机',
        },
        {
          prop: 'linkman',
          label: '员工姓名',
        },
        {
          prop: 'employeeNumber',
          label: '员工工号',
        },
        {
          prop: 'lockFlagName',
          label: '职位',
        },
      ],
    };
  },
  methods: {
    getListApi: workerList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
